import { ref, reactive } from 'vue';

const toasts = ref([]);
let toastId = 0;

export const useToast = () => {
  const addToast = (message, type = 'success', duration = 3000) => {
    const id = toastId++;
    const toast = {
      id,
      message,
      type,
      visible: true
    };
    
    toasts.value.push(toast);
    
    // Auto-remove after duration
    if (duration > 0) {
      setTimeout(() => {
        removeToast(id);
      }, duration);
    }
    
    return id;
  };
  
  const removeToast = (id) => {
    const index = toasts.value.findIndex(t => t.id === id);
    if (index > -1) {
      toasts.value[index].visible = false;
      setTimeout(() => {
        toasts.value.splice(index, 1);
      }, 300); // Wait for animation
    }
  };
  
  const success = (message, duration = 3000) => {
    return addToast(message, 'success', duration);
  };
  
  const error = (message, duration = 5000) => {
    return addToast(message, 'error', duration);
  };
  
  const warning = (message, duration = 4000) => {
    return addToast(message, 'warning', duration);
  };
  
  const info = (message, duration = 3000) => {
    return addToast(message, 'info', duration);
  };
  
  return {
    toasts,
    addToast,
    removeToast,
    success,
    error,
    warning,
    info
  };
};